import type { BillboardDetailData } from '@/features/billboards/api/billboardApi';
import { ExpandableCopy } from '@/features/billboards/components/detail/ExpandableCopy';
import { InfoRow } from '@/features/billboards/components/detail/InfoRow';
import { SectionTitle } from '@/features/billboards/components/detail/SectionTitle';
import { formatFieldLabel } from '@/features/billboards/utils/billboardDetailUtils';

type VenueSectionProps = {
  billboard: BillboardDetailData;
};

/* Modified by: Ishan | Soft-contrast venue & location card */
export function VenueSection({ billboard }: VenueSectionProps) {
  return (
    <section className="bg-white rounded-[24px] p-[22px] shadow-[0_10px_30px_rgba(60,40,120,0.05)] border border-[#EEEBF8]">
      <SectionTitle
        title="Venue & location"
        subtitle="Where this screen is placed"
      />
      <dl>
        <InfoRow
          label="Location type"
          value={formatFieldLabel(billboard.locationType)}
        />
        <InfoRow
          label="Screen type"
          value={formatFieldLabel(billboard.screenType)}
        />
        <InfoRow
          label="Venue type"
          value={formatFieldLabel(billboard.VenueType)}
        />
        <InfoRow
          label="Venue sub type"
          value={formatFieldLabel(billboard.VenueSubType)}
        />
      </dl>
      <div className="mt-4 border-t border-[#F3F1FA] pt-4">
        <div className="text-[14px] font-extrabold text-[#3A3660] mt-1 mb-1.5">
          Specification
        </div>
        <ExpandableCopy
          text={billboard.specification}
          fallback="No specification provided."
        />
      </div>
    </section>
  );
}
